'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('./../process/pc-slate-tools');

var _ShopifySection2 = require('./../sections/ShopifySection');

var _Responsive = require('./../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
/*
 *  Product Template Scripts
 *    Scripts that are only meant to run on the Product Template.
 *
 *  Version:
 *    1.0.0 - 2020/03/12
 */

var COLLECTION_TEMPLATE_CONTAINER = '[data-collection-template]';
var COUNTER_SELECTOR = '[data-header-cart-count]';
var BUTTON_MINUS = '[data-quantity-selector-minus]';
var BUTTON_PLUS = '[data-quantity-selector-plus]';
var QUANTITY_BOX = '[data-quantity-selector-field]';
var CART_ADD_BUTTON = '[data-cart-add-button]';
var CLASS_HIDDEN = 'is-hidden';
var CLASS_DISABLED = 'is-disabled';

var CollectionTemplate = function (_ShopifySection) {
	(0, _inherits3.default)(CollectionTemplate, _ShopifySection);

	function CollectionTemplate(container) {
		(0, _classCallCheck3.default)(this, CollectionTemplate);

		var _this = (0, _possibleConstructorReturn3.default)(this, (CollectionTemplate.__proto__ || Object.getPrototypeOf(CollectionTemplate)).call(this, container));

		_this.container = container;

		/*$('[data-collection-template]').on( "click", "button", function( event ) {
      console.log('entered');//event.preventDefault();
      console.log( $( this ).text() );
  });*/
		//Elements
		container.on('click', CART_ADD_BUTTON, function (e) {
			return _this.onAddClickColl(e);
		});
		container.on('click', BUTTON_MINUS, function (e) {
			return _this.qtyProcess(e, 0);
		});
		container.on('click', BUTTON_PLUS, function (e) {
			return _this.qtyProcess(e, 1);
		});
		container.on('change', QUANTITY_BOX, function (e) {
			return _this.onChangeItem(e);
		});

		return _this;
	}

	(0, _createClass3.default)(CollectionTemplate, [{
		key: 'onAddClickColl',
		value: function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
				var _this2 = this;

				var self, id, qty, tiers, collection, product;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								e.preventDefault();
								e.stopPropagation();
								self = (0, _jquery2.default)(e.currentTarget);
								id = self.closest('[data-product-thumbnail]').data('variant-id');
								qty = self.closest('[data-product-thumbnail-add-to-cart]').find('[data-quantity-selector-field]').val();
								tiers = JSON.parse(self.closest('[data-product-thumbnail]').find('[data-pricing-tiers]').html());

								if (!self.hasClass(CLASS_DISABLED)) {
									_context.next = 8;
									break;
								}

								return _context.abrupt('return');

							case 8:
								_context.prev = 8;

								self.html('Adding...');
								_context.next = 12;
								return (0, _pcSlateTools.addToCart)(id, qty, tiers);

							case 12:
								//this.wasAdded = true;//This will tell our button to temporarily display the "Was added" text
								(0, _jquery2.default)('[data-show-cart-drawer]').click();
								collection = self.closest('[data-collection-template]').find('h2').html();
								product = JSON.parse(self.closest('[data-product-thumbnail]').find('[data-product-json]').html());


								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									'page_type': 'add_to_cart',
									'event': 'MagnetUK_add_to_cart', //create a custom event in GTM
									'items': [{
										'item_id': product.sku,
										'item_name': product.name,
										'price': product.offers[0].price,
										'item_brand': product.brand.name,
										'item_category': collection,
										'item_list_name': collection,
										'description': product.description,
										'quantity': qty
									}]
								});

								_context.next = 25;
								break;

							case 19:
								_context.prev = 19;
								_context.t0 = _context['catch'](8);

								console.error(_context.t0);
								self.html('Add to Cart');
								if (_context.t0.description) alert(_context.t0.description);
								return _context.abrupt('return');

							case 25:

								self.html('Added!');
								setTimeout(function () {
									return _this2.updateButton(self, id);
								}, 1000);

							case 27:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[8, 19]]);
			}));

			function onAddClickColl(_x) {
				return _ref.apply(this, arguments);
			}

			return onAddClickColl;
		}()
	}, {
		key: 'updateButton',
		value: function updateButton(o) {
			o.html('Add to Cart');
			var cart = (0, _pcSlateTools.getCurrentCart)();
			//Update header cart counter
			this.updateCounter(cart.item_count);
			//TODO: update inventory data max and min values for quantity selector
		}
	}, {
		key: 'qtyProcess',
		value: function qtyProcess(e, t) {
			e.preventDefault();
			e.stopPropagation();
			var self = (0, _jquery2.default)(e.currentTarget);
			var max = self.closest('[data-quantity-selector]').data("max");
			var qty_field = self.closest("div").find("input[name=qty]");
			var qty = qty_field.val();
			if (t == 0) {
				if (qty > 1) qty--;else {
					self.attr("disabled", true);return false;
				}
				self.closest("div").find(".is-plus").attr("disabled", false);
			} else {
				if (max == null || qty < max) qty++;else {
					self.attr("disabled", true);return false;
				}
				self.closest("div").find(".is-minus").attr("disabled", false);
			}
			qty_field.val(qty);
		}
	}, {
		key: 'onChangeItem',
		value: function onChangeItem(e) {
			var self = (0, _jquery2.default)(e.currentTarget);
			var max = self.closest('[data-quantity-selector]').data("max");
			var q = self.val();
			var line = self.data('index');
			self.closest("div").find(".is-minus").attr("disabled", false);self.closest("div").find(".is-plus").attr("disabled", false);
			if (q <= 1) {
				self.closest("div").find(".is-minus").attr("disabled", true);q = 1;self.val(q);
			}
			if (max != null && q >= max) {
				self.closest("div").find(".is-plus").attr("disabled", true);q = max;self.val(q);
			}
		}
	}, {
		key: 'updateCounter',
		value: function updateCounter(count) {
			(0, _jquery2.default)(COUNTER_SELECTOR).html(count);

			if (count <= 0) {
				(0, _jquery2.default)(COUNTER_SELECTOR).addClass(CLASS_HIDDEN);
			}
		}
	}]);
	return CollectionTemplate;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(COLLECTION_TEMPLATE_CONTAINER, CollectionTemplate);